import { useState, useEffect } from 'react';

import {
  Button,
  Heading,
  Flex,
  SearchInput,
  SearchInputField,
  PopoverTrigger,
} from '@frontend/components';

import { useDebounce } from 'utils/hooks';

import type { InputEvent, NotificationFilterControlsProps } from '../types';
import FiltersPopover from './FiltersPopover';

const NotificationFilterControls = ({
  setFilters,
  filters,
  isFiltersPopoverOpen,
  setIsFiltersPopoverOpen,
}: NotificationFilterControlsProps) => {
  const [input, setInput] = useState('');

  const debouncedInput = useDebounce(input, 250);

  useEffect(() => {
    if (!input) return;

    setFilters({ ...filters, page: 1, searchTerm: debouncedInput });
  }, [debouncedInput, filters, input, setFilters]);

  const handleClear = () => {
    setInput('');
    setFilters({
      ...filters,
      page: 1,
      searchTerm: undefined,
    });
  };

  const handleChange = (e: InputEvent) => {
    if (!e.target.value) handleClear();
    else setInput(e.target.value);
  };

  return (
    <Flex
      flexDir="row"
      marginBottom={2}
      padding={0}
      flexWrap={{ base: 'wrap', tablet: 'nowrap' }}
      maxWidth={{ desktop: '40%', tablet: '100%' }}
    >
      <Heading marginRight={2}>Notifications</Heading>
      <Flex flex="1 0 auto">
        <SearchInput
          mode="live"
          size="md"
          onChange={(e) => handleChange(e)}
          onClear={handleClear}
          value={input || ''}
          marginRight={2}
          marginTop={{ base: 1, tablet: 0 }}
          marginBottom={{ base: 1, tablet: 0 }}
        >
          <SearchInputField placeholder="Search notifications" />
        </SearchInput>
        <FiltersPopover
          isOpen={isFiltersPopoverOpen}
          onClose={() => setIsFiltersPopoverOpen(false)}
          filters={filters}
          setFilters={setFilters}
        >
          <PopoverTrigger>
            <Button
              variant="secondary"
              onClick={() => setIsFiltersPopoverOpen(true)}
              marginTop="auto"
              marginBottom="auto"
            >
              Filter
            </Button>
          </PopoverTrigger>
        </FiltersPopover>
      </Flex>
    </Flex>
  );
};

export default NotificationFilterControls;
